import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-info-message',
  templateUrl: './dialog-info-message.component.html',
  styleUrl: './dialog-info-message.component.scss',
  standalone: false,
})
export class DialogInfoMessageComponent {
  protected title = signal<string>('');
  protected message = signal<string>('');

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: { title: string; message: string },
    private dialogRef: MatDialogRef<DialogInfoMessageComponent, any | null>,
  ) {
    this.title.set(data.title);
    this.message.set(
      data.message.replace('set at least one table for Discovery', '<b>set at least one table for Discovery</b>'),
    );
  }

  onClose() {
    this.dialogRef.close();
  }
}
